import { render, staticRenderFns } from "./announcements.vue?vue&type=template&id=1f518970&"
import script from "./announcements.vue?vue&type=script&lang=ts&"
export * from "./announcements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports